module.exports = {
  title: "",

  logo: "",

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: false,

  topMenu: true,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: "production",

  keepAlive: false,

  routesFromMock: true,

  dataFieldName: "Data",
  extValueField: "ExtValue",
  codeFieldName: "Code",

  successState: 200,

  // requestTimeout: 10000,
  requestTimeout: 100000,

  tokenKey: "token",

  userKey: "user",

  tokenHeaderName: "Authorization",

  tokenTypeField: "token_type",

  tokenValueField: "access_token",

  tokenRefField: "refresh_token",

  tokenExpiresField: "expires_in",

  roleField: "Roles",

  keyField: "ID",

  nameField: "UserName",

  avatarField: "HeadImageUrl",

  authorField: "Policies",

  pageFieldName: "PageIndex",

  totalField: "TotalCount",

  sizeFieldName: "PageSize",

  defaultPageSize: 10,

  uploadUrl: "/api/upload/upload",

  imageTypes: ["image/jpeg", "image/png"],

  imageMaxSize: 10240, // kb

  fileMaxSize: 512000, // kb

  lang: false,

  flow: false,

  baiduMapAk: "PqXv7L2PZkDde0DQNT8AuQHwNyhvuOCQ",
}
